import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backend_url } from "../../App";
import HeaderTitle from "../HederTitle/HeaderTitle";

const Variety = () => {
  const [varieties, setVarieties] = useState([]);
  const navigate = useNavigate();

  const allPlaces = [
    "Place 1",
    "Place 2",
    "Place 3",
    "Place 4",
    "Place 5",
    "Place 6",
    "Place 7",
  ];

  useEffect(() => {
    fetchVarieties();
  }, []);

  const fetchVarieties = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/variety`);
      setVarieties(response.data);
    } catch (error) {
      console.error("Error fetching varieties:", error);
    }
  };

  //Map varieties based on "placeTo"
  const placeMap = {};
  varieties.forEach((variety) => {
    placeMap[variety.placeTo] = variety;
  });

  //Grid size definitions
  const getColSpan = (index) => {
    const colSpans = [
      "col-span-2 row-span-2", // Larger first item
      "col-span-2",
      "col-span-2",
      "col-span-3",
      "col-span-3",
      "col-span-2",
      "col-span-2",
    ];
    return colSpans[index] || "col-span-2";
  };

  const getHeightClass = (index) => {
    return index === 0 ? "h-60 md:h-96" : "h-40 md:h-48";
  };

  return (
    // <div className="px-6 py-10 bg-white">
    //   <HeaderTitle Header="Variety of Accessories" />
    //   <div className="grid grid-cols-9 grid-rows-2 mx-5 gap-4 bg-center grid-flow-dense">
    //     {allPlaces.map((place, index) => {
    //       const item = placeMap[place]; // Get variety by place

    //       return (
    //         <div
    //           key={index}
    //           className={`border-4 border-b-0 border-purple-400 overflow-hidden relative rounded-tr-xl ${getColSpan(index)} flex items-center justify-center`}
    //           onClick={() => item?.routeTo && navigate(`/collections/${item.routeTo}`)}
    //           style={{ cursor: item?.routeTo ? "pointer" : "default" }}
    //         >
    //           {item ? (
    //             <>
    //               <img crossOrigin="anonymous"
    //                 src={item.image ? `${item.image}` : "/images/placeholder.png"}
    //                 alt={item.collectionName}
    //                 className={`w-full ${getHeightClass(index)} object-cover hover:scale-105 transition-transform duration-300`}
    //               />
    //               <p className="absolute top-3 left-3 text-white font-black text-sm bg-opacity-50 px-3 py-1 drop-shadow-lg bg-black rounded">
    //                 {item.collectionName}
    //               </p>
    //             </>
    //           ) : (
    //             <div className="text-gray-400 text-sm">
    //               {place}
    //             </div>
    //           )}
    //         </div>
    //       );
    //     })}
    //   </div>
    // </div>

    <div className="px-6 py-10 bg-white">
      <HeaderTitle Header="Variety of Accessories" />

      {/* Mobile: horizontal scroll | Desktop: grid */}
      {/* <div className="flex md:grid md:grid-cols-9 md:grid-rows-2  md:grid-flow-dense overflow-x-auto md:overflow-visible gap-4 no-scrollbar"> */}
      <div className="flex flex-col md:grid md:grid-cols-9 md:grid-rows-2 md:grid-flow-dense overflow-y-auto md:overflow-visible gap-4 no-scrollbar">
        {allPlaces.map((place, index) => {
          const item = placeMap[place];

          return (
            <div
              key={index}
      className={`border-4 border-purple-400 overflow-hidden relative rounded-xl
            w-[250px] md:w-auto mx-auto md:mx-0 md:flex-shrink-0
            ${getColSpan(index)} flex items-center justify-center`}
              onClick={() =>
                item?.routeTo && navigate(`/collections/${item.routeTo}`)
              }
              style={{ cursor: item?.routeTo ? "pointer" : "default" }}
            >
              {item ? (
                <>
                  <img
                    crossOrigin="anonymous"
                    src={
                      item.image ? `${item.image}` : "/images/placeholder.png"
                    }
                    alt={item.collectionName}
                    className={`w-full ${getHeightClass(
                      index
                    )} object-cover hover:scale-105 transition-transform duration-300`}
                  />
                  <p className="absolute top-3 left-3 text-white font-black text-sm bg-opacity-50 px-3 py-1 drop-shadow-lg bg-black rounded">
                    {item.collectionName}
                  </p>
                </>
              ) : (
                <div className="text-gray-400 text-sm">{place}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Variety;
